import {Component, Input, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {ExtensionEvent, Hort360PropertySummary} from '../../../../functions/src/types';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {ApiService} from '../../services/api.service';
import {PropertyService} from '../../services/property.service';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {LocalStorageService} from '@efaps/ngx-store';
import {RSDialog} from "../../../libs/rsnotify/rsdialog";
import {AddEventComponent} from "../add-event/add-event.component";
import {UpdatePropertyContactComponent} from "../update-property-contact/update-property-contact.component";
import defaultValues = RSDialog.defaultValues;
import {RSLoadingModalService} from "../../../libs/rsloading/rsloading.service";
import {DataService} from "../../services/data.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-grower-others',
  templateUrl: './grower-others.component.html',
  styleUrls: ['./grower-others.component.scss']
})
export class GrowerOthersComponent implements OnInit {
  public isSearching = false;
  public searchResults: Hort360PropertySummary[] | null = null;
  private searchEvent = null;
  private lastSearch = null;
  @Input('highlighted') public highlighted: Hort360PropertySummary[] = [];
  @Input('savedSearch') public savedSearch = true;
  @Input('searchTerm') public searchTerm = '';
  @Output('selected') selected = new EventEmitter<Hort360PropertySummary>();

  displayedColumns: string[] = ['id', 'growerDescription', 'property', 'nameAddress', 'selected']; // <!-- property -->
  dataSource = null;
  private dataSort = null;
  private dataPaginator = null;
  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSort = sort;
    if (this.dataSort && this.dataSource) {
      this.dataSource.sort = this.dataSort;
    }
  }
  @ViewChild(MatPaginator) set paginator(paginator: MatPaginator) {
    this.dataPaginator = paginator;
    if (this.dataPaginator && this.dataSource) {
      this.dataSource.paginator = this.dataPaginator;
    }
  }

  constructor(
    private apiService: ApiService,
    private rsDialog: RSDialogService,
    private loadingService: RSLoadingModalService,
    private lsService: LocalStorageService,
    private router: Router,
    private dataService: DataService,
    private propertyService: PropertyService
  ) { }

  isHighlighted(property: Hort360PropertySummary) {
    return !this.highlighted || !!this.highlighted.find(p => p.id === property.id);
  }

  public async searchGrowers() {
    this.searchTerm = this.searchTerm.trim() || '';
    this.dataSource.filter = this.searchTerm.trim().toLowerCase();
  }

  selectProperty(property: Hort360PropertySummary) {
    this.selected.emit(property);
  }

  ngOnInit(): void {
    this.searchTerm = (this.savedSearch ? this.lsService.get('otherSearch') : '') || '';

    this.dataSource = new MatTableDataSource([]);
    this.propertyService.summaryContactsChanged.subscribe(contacts => {
      this.searchResults = Object.values(contacts);
      this.dataSource = new MatTableDataSource(this.searchResults);
      this.dataSource.sort = this.dataSort;
      this.dataSource.paginator = this.dataPaginator;
      this.isSearching = false;

      this.searchGrowers();
    });
  }

  public addOther(otherId: string = null) {
    console.log('addOther::: ', otherId);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Add / Edit Other Contact';
    dialogOptions.cancelable = false;
    dialogOptions.closeButton = false;
    dialogOptions.size = RSDialog.Size.MEDIUM;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add our custom component;
    dialogOptions.component = UpdatePropertyContactComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: {other: Hort360PropertySummary } =
      {
        other: this.propertyService.getPropertySummary(otherId) || {} as Hort360PropertySummary
      };

    console.log('updateEvent::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialog.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.NO) {
          this.router.navigate(['growers', oValues.other.id]);
        } else if (v === defaultValues.YES) {
          this.loadingService.show();
          try {
            await this.dataService.addUpdateOtherProperty(oValues.other);
          } catch (e) {
            console.error(e);
            this.rsDialog.showErrorDialog('Something went wrong. ' + e.message);
          }
          this.loadingService.hide();
        }
      },
      (e) => console.error
    );
  }

}
